import { Modal, Typography, Space } from "antd";
import { UnlockOutlined, SendOutlined, CloseOutlined } from "@ant-design/icons";
import React from "react";
import LabelTextarea from "../../../components/input/LabelTextarea";
import { startSolicitarLiberacionDeAsistenciaParaOP } from "../../../context/actions/opServiciosActions";
import { useDispatch } from "react-redux";

const { Text } = Typography;

export const ModalSolicitaLiberar = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const [body, setBody] = React.useState({});

  const handlechange = ({ target }) =>
    setBody({ ...body, [target.name]: target.value });

  const submit = () => {
    dispatch(startSolicitarLiberacionDeAsistenciaParaOP(body));
    setOpen(false);
    setBody({});
  };

  const handleCancel = () => {
    setOpen(false);
    setBody({});
  };

  const disabled = !body.motivo || !body.folios;

  return (
    <Modal
      title={
        <span>
          <UnlockOutlined style={{ marginRight: 8 }} />
          Solicitar Liberar Asistencias para Crear OP
        </span>
      }
      open={open}
      onCancel={handleCancel}
      onOk={submit}
      okText={<><SendOutlined style={{ marginRight: 6 }} />Solicitar</>}
      cancelText={<><CloseOutlined style={{ marginRight: 6 }} />Cancelar</>}
      okButtonProps={{ disabled }}
      cancelButtonProps={{ danger: true, type: 'primary' }}
      className="pagos-v2-modal"
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <LabelTextarea
          name="motivo"
          onChange={handlechange}
          value={body.motivo}
          label="Motivo de la solicitud"
          rows={3}
        />
        <div>
          <LabelTextarea
            name="folios"
            onChange={handlechange}
            value={body.folios}
            label="Folios de Asistencia"
            rows={3}
          />
          <Text type="secondary" style={{ fontSize: 12 }}>
            Sin espacios y separados por coma, ejemplo: AGUI_0001,AGUI_0002
          </Text>
        </div>
      </Space>
    </Modal>
  );
};
